module.exports = __webpack_public_path__ + "static/design-ffc05472ce09482f7ddfaa4774c8f01f.png";